import src from "IMAGE";
export default { src, width: 670, height: 319, blurWidth: 0, blurHeight: 0};
